<template>
	<DialogFormDialog ref="dialog" :strings="strings" width="auto" @reset="reset">
		<v-row>
			<v-col cols="12">
				<v-select
					v-model="selectedDevice"
					label="Device"
					:items="devicesWithCommands"
					:rules="rules"
				/>
				<v-select
					v-model="values.path"
					label="Command"
					:items="commands"
					:rules="rules"
				/>
			</v-col>
			<v-col cols="12">
				<k4-model-arg-form
					:args="values.args"
					:node="selectedDevice"
					:subpath="subpath"
				></k4-model-arg-form>
			</v-col>
		</v-row>
	</DialogFormDialog>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

const initData = () => ({
	selectedDevice: null,

	values: {
		guid: null,
		path: null,
		order: 1,
		args: {},
	},
});

export default {
	data: initData,

	computed: {
		strings() {
			const _strings = strings.live.scenes.commandStepDialog;
			return this.values.guid ? _strings.update : _strings.new;
		},

		rules() {
			return [(val) => !!val || "Required"];
		},

		subpath() {
			if (!this.values.path) return null;
			return this.values.path.split("/").slice(-2).join("/");
		},

		devicesWithCommands() {
			return _.map(
				this.$store.getters["controller/nodes/devicesByType"]("commands"),
				(node) => ({
					text: _.startCase(
						`${node.path.split("/").reverse()[1]} ${node.name}`
					),
					value: node,
				})
			);
		},

		commands() {
			if (!this.selectedDevice) return [];

			const devicePath = this.selectedDevice.path;
			let commands = _.get(this.selectedDevice, "commands", []);
			commands = _.keys(commands);
			commands = _.map(commands, (commandName) => ({
				text: _.startCase(commandName),
				value: `${devicePath}/commands/${commandName}`,
			}));
			return commands;
		},
	},

	watch: {
		values: {
			deep: true,
			handler(newVal) {
				const payload = {
					...newVal,
					args: JSON.stringify(newVal.args),
				};
				this.$refs.dialog.updateFormData(payload);
			},
		},
	},

	methods: {
		reset() {
			Object.assign(this, initData());
		},

		pop(handler, node) {
			if (node) {
				this.values.guid = node.guid;
				this.values.path = node.targetPath;
				this.values.order = node.properties.order.value;
				const args = node.properties.args.value;
				this.values.args = typeof args === "string" ? JSON.parse(args) : args;

				// Get selected device from target event
				this.selectedDevice = this.$store.getters[
					"controller/nodes/nodeByGuid"
				](_.get(node, "target.parentDevice.guid"));
			}
			return this.$refs.dialog.pop(handler);
		},
	},
};
</script>
